// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___9bb5181a3f43c87c550","cls2":"ImpactHubProfileCard-cls2___ed4024e8d3aa036908f ImpactHubProfileCard-cls1___9bb5181a3f43c87c550"};